import React from "react";

import { withRouter } from "react-router-dom";
import TopAssetsLeasableArea from "../../widgets/office/asset/TopAssetsLeasableArea";
import LeasedSpaceShareTopAssets from "../../widgets/office/asset/LeasedSpaceShareTopAssets";
// import MySelectedAssets from "../../widgets/office/asset/MySelectedAssets";
// import RecentlySearchedAssets from "../../widgets/office/asset/RecentlySearchedAssets";
import TopAssetsGrossLeasingVolume from "../../widgets/office/asset/TopAssetsGrossLeasingVolume";
import AreaExpiringMonthsTopAssets from "../../widgets/office/asset/AreaExpiringMonthsTopAssets";
import PassingRentTrendsTopAssets from "../../widgets/office/asset/PassingRentTrendsTopAssets";
import PassingRentTrendsTopFiveAssets from "../../widgets/office/asset/PassingRentTrendsTopFiveAssets";
import ErrorBoundaries from "../../services/utilities/ErrorBoundaries";
import RecentNews from "../../widgets/office/asset/RecentNews";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
class Asset1 extends React.Component {
  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
  }

  render() {
    return (
      <div className="container-fluid" id="page">
        <div className="row mb-4">
          {/* <div className="col-12">
            <button
              onClick={(e) => {
                this.getPdf();
              }}
            >
              Get Pdf
            </button>
          </div> */}
          <div className="col-lg-8">
            <TopAssetsLeasableArea />
          </div>
          <div className="col-lg-4">
            <ErrorBoundaries>
              <LeasedSpaceShareTopAssets />
            </ErrorBoundaries>
          </div>
        </div>
        {/* <div className="row mb-4">
          <div className="col-lg-8">
            <MySelectedAssets />
          </div>
          <div className="col-lg-4">
            <RecentlySearchedAssets />
          </div>
        </div> */}
        <div className="row mb-4">
          <div className="col-lg-8">
            <ErrorBoundaries>
              <TopAssetsGrossLeasingVolume />
            </ErrorBoundaries>
          </div>
          <div className="col-lg-4">
            <ErrorBoundaries>
              <AreaExpiringMonthsTopAssets />
            </ErrorBoundaries>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <ErrorBoundaries>
              <PassingRentTrendsTopAssets />
            </ErrorBoundaries>
          </div>
          <div className="col-lg-6">
            <ErrorBoundaries>
              <PassingRentTrendsTopFiveAssets />
            </ErrorBoundaries>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Asset1);
